import type { ChartOptions } from 'chart.js';
import type { BdChartLegendOptions } from './legend-options';

/**
 * Converts domain legend options to Chart.js legend plugin options
 * and merges them with existing chart options.
 */
export function applyLegendOptions(
  options: ChartOptions,
  legendConfig: BdChartLegendOptions
): ChartOptions {
  const legendOptions: Record<string, unknown> = {
    display: legendConfig.display,
  };

  if (legendConfig.position) {
    legendOptions['position'] = legendConfig.position;
  }

  if (legendConfig.align) {
    legendOptions['align'] = legendConfig.align;
  }

  if (legendConfig.title) {
    legendOptions['title'] = {
      display: true,
      text: legendConfig.title,
    };
  }

  const existingPlugins = (options.plugins ?? {}) as Record<string, unknown>;
  const existingLegend = (existingPlugins['legend'] ?? {}) as Record<
    string,
    unknown
  >;

  return {
    ...options,
    plugins: {
      ...existingPlugins,
      // Merged, not replaced (BDA-6126). The four keys above are the whole of
      // what a stored legend configuration can say, and they still win — but
      // a renderer may have computed the legend's CONTENT as well (a radial
      // cube tile names its rings through `labels.generateLabels` and pairs
      // that with its own `onClick`). Replacing the object dropped that the
      // moment a tile configured a position, which is exactly when the legend
      // is on screen to be wrong.
      legend: { ...existingLegend, ...legendOptions },
    } as ChartOptions['plugins'],
  };
}
